(() => {
  if (window.EznSharedBackground) {
    window.EznSharedBackground.setup();
    return;
  }

  const controller = {
    observer: null,
    setup() {
      if (this.observer) this.observer.disconnect();

      document.querySelectorAll('.ezn-shared-background-section').forEach((element) => {
        element.classList.remove('ezn-shared-background-section', 'ezn-shared-background-end');
        element.style.removeProperty('background-image');
        element.style.removeProperty('background-repeat');
        element.style.removeProperty('background-size');
        element.style.removeProperty('background-position');
      });

      const start = document.querySelector('.ezn-shared-background-start[data-ezn-shared-background]');
      if (!start) return;

      const collectionSection = start.closest('.shopify-section');
      const reviewSection = collectionSection && collectionSection.nextElementSibling;
      if (!collectionSection || !reviewSection) return;

      collectionSection.classList.add('ezn-shared-background-section');
      reviewSection.classList.add('ezn-shared-background-section', 'ezn-shared-background-end');

      const source = start.dataset.eznSharedBackground;
      const image = new Image();
      const positionBackground = () => {
        if (!image.naturalWidth || !image.naturalHeight || !collectionSection.isConnected || !reviewSection.isConnected) return;

        const width = collectionSection.getBoundingClientRect().width;
        const firstHeight = collectionSection.getBoundingClientRect().height;
        const totalHeight = firstHeight + reviewSection.getBoundingClientRect().height;
        const imageRatio = image.naturalWidth / image.naturalHeight;
        const areaRatio = width / totalHeight;
        const renderedWidth = areaRatio > imageRatio ? width : totalHeight * imageRatio;
        const renderedHeight = areaRatio > imageRatio ? width / imageRatio : totalHeight;
        const verticalOffset = totalHeight - renderedHeight;

        [collectionSection, reviewSection].forEach((element) => {
          element.style.backgroundImage = `url("${source}")`;
          element.style.backgroundRepeat = 'no-repeat';
          element.style.backgroundSize = `${renderedWidth}px ${renderedHeight}px`;
        });

        collectionSection.style.backgroundPosition = `0 ${verticalOffset}px`;
        reviewSection.style.backgroundPosition = `0 ${verticalOffset - firstHeight}px`;
      };

      image.addEventListener('load', positionBackground, { once: true });
      image.src = source;
      this.observer = new ResizeObserver(positionBackground);
      this.observer.observe(collectionSection);
      this.observer.observe(reviewSection);
    }
  };

  window.EznSharedBackground = controller;
  controller.setup();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => controller.setup()));
  document.addEventListener('shopify:section:reorder', () => requestAnimationFrame(() => controller.setup()));
})();
